// extracted by mini-css-extract-plugin
export var brand = "_6s-9";
export var compact = "_6s-6";
export var extraSmall = "_6s-7";
export var icon = "_6s-0";
export var large = "_6s-4";
export var light = "_6s-1";
export var medium = "_6s-5";
export var outline = "_6s-b";
export var primaryDark = "_6s-a";
export var primaryLight = "_6s-8";
export var primaryModern = "_6s-c";
export var success = "_6s-2";
export var successSolid = "_6s-3";